import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../../../../utils";
import { createProformaDTO, GetAllIVReimbursementDTO, GetAllIVReimbursementFiltersDTO, GetAllProformaFiltersDTO, GetAllProformaResponseDTO, IVReimbursementAssignmentEstimatedCostDTO, IVReimbursementDTO, ReimbursementTypeEnum, UpdateProformaDTO } from "./dataservice/dto";
import { NewIVReimbursementService } from "./dataservice/service";

interface IVReimbursementState {
    // REQUEST
    reimbursementCreationRequest: IVReimbursementDTO
    reimbursementUpdateRequest: IVReimbursementDTO
    reimbursementIdToUpdate: string
    incProformaId: string
    createProformaRequest: createProformaDTO
    updateProformaRequest: UpdateProformaDTO
    getAllProformaResponse?: GetAllProformaResponseDTO
    // STATUS
    reimbursementCreationStatus: PromiseStatuses
    reimbursementUpdateStatus: PromiseStatuses
    reimbursementDeleteStatus: PromiseStatuses
    getReimbursementAssignmentCostEstimatesStatus: PromiseStatuses
    getReimbursementByInspectorCodeAndTypeStatus: PromiseStatuses
    getAllReimbursementStatus: PromiseStatuses
    getReimbursementByIdStatus: PromiseStatuses
    createProformaRequestStatus: PromiseStatuses
    getAllProformaStatus: PromiseStatuses
    updateProformaRequestStatus: PromiseStatuses

    // RESPONSE
    getReimbursementAssignmentCostEstimatesResponse?: IVReimbursementAssignmentEstimatedCostDTO
    getReimbursementByInspectorCodeAndTypeResponse?: IVReimbursementDTO
    getAllReimbursementResponse?: GetAllIVReimbursementDTO
    getReimbursementByIdResponse?: IVReimbursementDTO

}

const initialState: IVReimbursementState = {
    reimbursementCreationRequest: {
        inspectionVisitIds: []
    },
    createProformaRequest: {
        inspectionVisitIds: [],
        assignmentId: ''
    },
    updateProformaRequest: {},
    reimbursementUpdateRequest: {
        inspectionVisitIds: []
    },
    reimbursementIdToUpdate: '',
    incProformaId: '',
    reimbursementCreationStatus: 'idle',
    reimbursementDeleteStatus: 'idle',
    reimbursementUpdateStatus: 'idle',
    getAllReimbursementStatus: 'idle',
    updateProformaRequestStatus: 'idle',
    getReimbursementAssignmentCostEstimatesStatus: 'idle',
    getReimbursementByIdStatus: 'idle',
    getReimbursementByInspectorCodeAndTypeStatus: 'idle',
    createProformaRequestStatus: 'idle',
    getAllProformaStatus: 'idle'
}

export const IVReimbursementCreation = createAsyncThunk(
    'IVReimbursement/Creation',
    async (data: IVReimbursementDTO, thunkApi): Promise<void> => {
        const ReimbursementService = NewIVReimbursementService()
        return ReimbursementService.CreateIVReimbursement(data).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const IVReimbursementUpdate = createAsyncThunk(
    'IVReimbursement/Update',
    async (request: { body: IVReimbursementDTO, id: string }, thunkApi): Promise<void> => {
        const ReimbursementService = NewIVReimbursementService()
        return ReimbursementService.UpdateIVReimbursement(request.body, request.id).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)



export const IVReimbursementDelete = createAsyncThunk(
    'IVReimbursement/Delete',
    async (id: string, thunkApi): Promise<void> => {
        const ReimbursementService = NewIVReimbursementService()
        return ReimbursementService.DeleteIVReimbursement(id).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const GetAllIVReimbursement = createAsyncThunk(
    'IVReimbursement/GetAll',
    async (filters: GetAllIVReimbursementFiltersDTO, thunkApi): Promise<GetAllIVReimbursementDTO> => {
        const ReimbursementService = NewIVReimbursementService()
        return ReimbursementService.GetAllIVReimbursement(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const GetIVReimbursementById = createAsyncThunk(
    'IVReimbursement/GetById',
    async (id: string, thunkApi): Promise<IVReimbursementDTO> => {
        const ReimbursementService = NewIVReimbursementService()
        return ReimbursementService.GetIVReimbursementById(id).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const GetIVReimbursementAssignmentCostEstimates = createAsyncThunk(
    'IVReimbursement/GetAssignmentCostEstimates',
    async (assignmentId: string, thunkApi): Promise<IVReimbursementAssignmentEstimatedCostDTO> => {
        const ReimbursementService = NewIVReimbursementService()
        return ReimbursementService.GetIVReimbursementAssignmentCostEstimates(assignmentId).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const GetIVReimbursementByInspectorCodeAndType = createAsyncThunk(
    'IVReimbursement/GetByInspectorCodeAndType',
    async (request: { inspectorCode: string, type: ReimbursementTypeEnum }, thunkApi): Promise<IVReimbursementDTO> => {
        const ReimbursementService = NewIVReimbursementService()
        return ReimbursementService.GetIVReimbursementByInspectorCodeAndType(request.inspectorCode, request.type).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

//PROFORMA

export const GetAllProforma = createAsyncThunk(
    'IVReimbursement/GetAllProforma',
    async (filters: GetAllProformaFiltersDTO, thunkApi): Promise<GetAllProformaResponseDTO> => {
        const ReimbursementService = NewIVReimbursementService()
        return ReimbursementService.GetAllProforma(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const UpdateProforma = createAsyncThunk(
    'IVReimbursement/UpdateProforma',
    async (request: { body: UpdateProformaDTO, id: string }, thunkApi): Promise<void> => {
        const ReimbursementService = NewIVReimbursementService()
        return ReimbursementService.UpdateProforma(request.body, request.id).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const CreateProforma = createAsyncThunk(
    'IVReimbursement/CreateProforma',
    async (data: createProformaDTO, thunkApi): Promise<void> => {
        const ReimbursementService = NewIVReimbursementService()
        return ReimbursementService.CreateProforma(data).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const IVReimbursementSlice = createSlice({
    name: 'ivReimbursement/slice',
    initialState,
    reducers: {
        // REQUEST [CREATION]
        setReimbursementCreationInspectionVisitIds: (state, action) => {
            state.reimbursementCreationRequest.inspectionVisitIds = action.payload
        },
        setReimbursementCreationAssignmentId: (state, action) => {
            state.reimbursementCreationRequest.assignmentId = action.payload
        },
        setReimbursementCreationInspectorCode: (state, action) => {
            state.reimbursementCreationRequest.inspectorCode = action.payload
        },
        setReimbursementCreationReimbursementType: (state, action) => {
            state.reimbursementCreationRequest.reimbursementType = action.payload
        },
        setReimbursementCreationPaymentType: (state, action) => {
            state.reimbursementCreationRequest.paymentType = action.payload
        },
        setReimbursementCreationAmount: (state, action) => {
            state.reimbursementCreationRequest.amount = action.payload
        },
        setReimbursementCreationNote: (state, action) => {
            state.reimbursementCreationRequest.note = action.payload
        },
        setReimbursementCreationUsedVehicle: (state, action) => {
            state.reimbursementCreationRequest.usedVehicle = action.payload
        },
        setReimbursementCreationCarModel: (state, action) => {
            state.reimbursementCreationRequest.carModel = action.payload
        },
        setReimbursementCreationCarNumberPlate: (state, action) => {
            state.reimbursementCreationRequest.carNumberPlate = action.payload
        },
        setReimbursementCreationCarType: (state, action) => {
            state.reimbursementCreationRequest.carType = action.payload
        },
        setReimbursementCreationDay: (state, action) => {
            state.reimbursementCreationRequest.day = action.payload
        },
        setReimbursementCreationDeparturePlace: (state, action) => {
            state.reimbursementCreationRequest.departurePlace = action.payload
        },
        setReimbursementCreationArrivalPlace: (state, action) => {
            state.reimbursementCreationRequest.arrivalPlace = action.payload
        },
        setReimbursementCreationReturnPlace: (state, action) => {
            state.reimbursementCreationRequest.returnPlace = action.payload
        },
        setReimbursementCreationKilometresTravelled: (state, action) => {
            state.reimbursementCreationRequest.kilometresTravelled = action.payload
        },
        setIncProformaToView: (state, action) => {
            state.incProformaId = action.payload
        },
        resetUpdateroformaStatus: (state) => {
            state.updateProformaRequestStatus = 'idle'
        },

        resetUpdateProforma: (state) => {
            state.updateProformaRequest = {}
        },

        resetReimbursementCreationRequest: (state) => {
            state.reimbursementCreationRequest = {
                inspectionVisitIds: []
            }
        },
        resetReimbursementCreationRequestButType: (state) => {
            state.reimbursementCreationRequest = {
                reimbursementType: state.reimbursementCreationRequest.reimbursementType,
                inspectionVisitIds: [],
                note: '',
                carModel: ''
            }
        },

        // REQUEST [UPDATE]
        setReimbursementIdToUpdate: (state, action) => {
            state.reimbursementIdToUpdate = action.payload
        },
        setReimbursementUpdateInspectionVisitIds: (state, action) => {
            state.reimbursementUpdateRequest.inspectionVisitIds = action.payload
        },
        setReimbursementUpdateAssignmentId: (state, action) => {
            state.reimbursementUpdateRequest.assignmentId = action.payload
        },
        setReimbursementUpdateInspectorCode: (state, action) => {
            state.reimbursementUpdateRequest.inspectorCode = action.payload
        },
        setReimbursementUpdateReimbursementType: (state, action) => {
            state.reimbursementUpdateRequest.reimbursementType = action.payload
        },
        setReimbursementUpdatePaymentType: (state, action) => {
            state.reimbursementUpdateRequest.paymentType = action.payload
        },
        setReimbursementUpdateAmount: (state, action) => {
            state.reimbursementUpdateRequest.amount = action.payload
        },
        setReimbursementUpdateNote: (state, action) => {
            state.reimbursementUpdateRequest.note = action.payload
        },
        setReimbursementUpdateUsedVehicle: (state, action) => {
            state.reimbursementUpdateRequest.usedVehicle = action.payload
        },
        setReimbursementUpdateCarModel: (state, action) => {
            state.reimbursementUpdateRequest.carModel = action.payload
        },
        setReimbursementUpdateCarNumberPlate: (state, action) => {
            state.reimbursementUpdateRequest.carNumberPlate = action.payload
        },
        setReimbursementUpdateCarType: (state, action) => {
            state.reimbursementUpdateRequest.carType = action.payload
        },
        setReimbursementUpdateDay: (state, action) => {
            state.reimbursementUpdateRequest.day = action.payload
        },
        setReimbursementUpdateDeparturePlace: (state, action) => {
            state.reimbursementUpdateRequest.departurePlace = action.payload
        },
        setReimbursementUpdateArrivalPlace: (state, action) => {
            state.reimbursementUpdateRequest.arrivalPlace = action.payload
        },
        setReimbursementUpdateReturnPlace: (state, action) => {
            state.reimbursementUpdateRequest.returnPlace = action.payload
        },
        setReimbursementUpdateKilometresTravelled: (state, action) => {
            state.reimbursementUpdateRequest.kilometresTravelled = action.payload
        },
        resetReimbursementUpdateRequest: (state) => {
            state.reimbursementUpdateRequest = {
                inspectionVisitIds: []
            }
        },

        setCreateProformaInspectionIds: (state, action) => {
            state.createProformaRequest.inspectionVisitIds = action.payload
        },

        setCreateProformaAssignmentId: (state, action) => {
            state.createProformaRequest.assignmentId = action.payload
        },
        setCreateProformaFiscalRegime: (state, action) => {
            state.createProformaRequest.fiscalRegime = action.payload
        },
        //UPDATE PROFORMA
        setUpdateProformaInvoiceDate: (state, action) => {
            state.updateProformaRequest.invoiceDate = action.payload
        },
        setUpdateProformaNumberInvoice: (state, action) => {
            state.updateProformaRequest.invoiceNumber = action.payload
        },
        setUpdateProformaInvoiceProtocol: (state, action) => {
            state.updateProformaRequest.invoiceProtocolId = action.payload
        },

        // STATUS
        resetReimbursementCreationStatus: (state) => {
            state.reimbursementCreationStatus = 'idle'
        },
        resetReimbursementUpdateStatus: (state) => {
            state.reimbursementUpdateStatus = 'idle'
        },
        resetReimbursementDeleteStatus: (state) => {
            state.reimbursementDeleteStatus = 'idle'
        },
        resetGetAllReimbursementStatus: (state) => {
            state.getAllReimbursementStatus = 'idle'
        },
        resetGetReimbursementAssignmentCostEstimatesStatus: (state) => {
            state.getReimbursementAssignmentCostEstimatesStatus = 'idle'
        },
        resetGetReimbursementByInspectorCodeAndTypeSAtatus: (state) => {
            state.getReimbursementByInspectorCodeAndTypeStatus = 'idle'
        },
        resetGetReimbursementByIdStatus: (state) => {
            state.getReimbursementByIdStatus = 'idle'
        },
        resetCreateProformaStatus: (state) => {
            state.createProformaRequestStatus = 'idle'
        }

    },
    extraReducers(builder) {
        builder

            // CREATION
            .addCase(IVReimbursementCreation.pending, (state) => {
                state.reimbursementCreationStatus = 'loading'
            })
            .addCase(IVReimbursementCreation.fulfilled, (state) => {
                state.reimbursementCreationStatus = 'successfully'
            })
            .addCase(IVReimbursementCreation.rejected, (state, action) => {
                state.reimbursementCreationStatus = 'failed'
            })

            // UPDATE
            .addCase(IVReimbursementUpdate.pending, (state) => {
                state.reimbursementUpdateStatus = 'loading'
            })
            .addCase(IVReimbursementUpdate.fulfilled, (state) => {
                state.reimbursementUpdateStatus = 'successfully'
            })
            .addCase(IVReimbursementUpdate.rejected, (state, action) => {
                state.reimbursementUpdateStatus = 'failed'
            })

            // DELETE
            .addCase(IVReimbursementDelete.pending, (state) => {
                state.reimbursementDeleteStatus = 'loading'
            })
            .addCase(IVReimbursementDelete.fulfilled, (state) => {
                state.reimbursementDeleteStatus = 'successfully'
            })
            .addCase(IVReimbursementDelete.rejected, (state, action) => {
                state.reimbursementDeleteStatus = 'failed'
            })

            // GET ALL
            .addCase(GetAllIVReimbursement.pending, (state) => {
                state.getAllReimbursementStatus = 'loading'
            })
            .addCase(GetAllIVReimbursement.fulfilled, (state, action) => {
                state.getAllReimbursementStatus = 'successfully'
                state.getAllReimbursementResponse = action.payload
            })
            .addCase(GetAllIVReimbursement.rejected, (state, action) => {
                state.getAllReimbursementStatus = 'failed'
            })

            // GET BY ID
            .addCase(GetIVReimbursementById.pending, (state) => {
                state.getReimbursementByIdStatus = 'loading'
            })
            .addCase(GetIVReimbursementById.fulfilled, (state, action) => {
                state.getReimbursementByIdStatus = 'successfully'
                state.getReimbursementByIdResponse = action.payload
            })
            .addCase(GetIVReimbursementById.rejected, (state, action) => {
                state.getReimbursementByIdStatus = 'failed'
            })

            // GET ASSIGNMENT COST ESTIMATES
            .addCase(GetIVReimbursementAssignmentCostEstimates.pending, (state) => {
                state.getReimbursementAssignmentCostEstimatesStatus = 'loading'
            })
            .addCase(GetIVReimbursementAssignmentCostEstimates.fulfilled, (state, action) => {
                state.getReimbursementAssignmentCostEstimatesStatus = 'successfully'
                state.getReimbursementAssignmentCostEstimatesResponse = action.payload
            })
            .addCase(GetIVReimbursementAssignmentCostEstimates.rejected, (state, action) => {
                state.getReimbursementAssignmentCostEstimatesStatus = 'failed'
            })

            // GET BY ID
            .addCase(GetIVReimbursementByInspectorCodeAndType.pending, (state) => {
                state.getReimbursementByInspectorCodeAndTypeStatus = 'loading'
            })
            .addCase(GetIVReimbursementByInspectorCodeAndType.fulfilled, (state, action) => {
                state.getReimbursementByInspectorCodeAndTypeStatus = 'successfully'
                state.getReimbursementByInspectorCodeAndTypeResponse = action.payload
            })
            .addCase(GetIVReimbursementByInspectorCodeAndType.rejected, (state, action) => {
                state.getReimbursementByInspectorCodeAndTypeStatus = 'failed'
            })

            // GET ALL PROFORMA
            .addCase(GetAllProforma.pending, (state) => {
                state.getAllProformaStatus = 'loading'
            })
            .addCase(GetAllProforma.fulfilled, (state, action) => {
                state.getAllProformaStatus = 'successfully'
                state.getAllProformaResponse = action.payload
            })
            .addCase(GetAllProforma.rejected, (state, action) => {
                state.getAllProformaStatus = 'failed'
            })

            // CREATE PROFORMA
            .addCase(CreateProforma.pending, (state) => {
                state.createProformaRequestStatus = 'loading'
            })
            .addCase(CreateProforma.fulfilled, (state, action) => {
                state.createProformaRequestStatus = 'successfully'
            })
            .addCase(CreateProforma.rejected, (state, action) => {
                state.createProformaRequestStatus = 'failed'
            })

            // UPDATE PROFORMA
            .addCase(UpdateProforma.pending, (state) => {
                state.updateProformaRequestStatus = 'loading'
            })
            .addCase(UpdateProforma.fulfilled, (state) => {
                state.updateProformaRequestStatus = 'successfully'
            })
            .addCase(UpdateProforma.rejected, (state) => {
                state.updateProformaRequestStatus = 'failed'
            })
    },
})

export const {
    // REQUEST
    setReimbursementCreationAmount,
    setReimbursementCreationArrivalPlace,
    setReimbursementCreationAssignmentId,
    setReimbursementCreationCarModel,
    setReimbursementCreationCarNumberPlate,
    setReimbursementCreationCarType,
    setReimbursementCreationDay,
    setReimbursementCreationDeparturePlace,
    setReimbursementCreationInspectionVisitIds,
    setReimbursementCreationInspectorCode,
    setReimbursementCreationKilometresTravelled,
    setReimbursementCreationNote,
    setReimbursementCreationPaymentType,
    setReimbursementCreationReimbursementType,
    setReimbursementCreationReturnPlace,
    setReimbursementCreationUsedVehicle,
    setReimbursementIdToUpdate,
    setReimbursementUpdateAmount,
    setReimbursementUpdateArrivalPlace,
    setReimbursementUpdateAssignmentId,
    setReimbursementUpdateCarModel,
    setReimbursementUpdateCarNumberPlate,
    setReimbursementUpdateCarType,
    setReimbursementUpdateDay,
    setReimbursementUpdateDeparturePlace,
    setReimbursementUpdateInspectionVisitIds,
    setReimbursementUpdateInspectorCode,
    setReimbursementUpdateKilometresTravelled,
    setReimbursementUpdateNote,
    setReimbursementUpdatePaymentType,
    setReimbursementUpdateReimbursementType,
    setReimbursementUpdateReturnPlace,
    setReimbursementUpdateUsedVehicle,
    //proforma
    setCreateProformaInspectionIds,
    setCreateProformaAssignmentId,
    setIncProformaToView,
    setUpdateProformaInvoiceProtocol,
    setUpdateProformaInvoiceDate,
    setUpdateProformaNumberInvoice,
    resetReimbursementCreationRequest,
    setCreateProformaFiscalRegime,
    resetReimbursementUpdateRequest,
    resetReimbursementCreationRequestButType,
    resetCreateProformaStatus,
    resetUpdateroformaStatus,
    resetUpdateProforma,

    // STATUS
    resetGetAllReimbursementStatus,
    resetGetReimbursementAssignmentCostEstimatesStatus,
    resetGetReimbursementByIdStatus,
    resetGetReimbursementByInspectorCodeAndTypeSAtatus,
    resetReimbursementCreationStatus,
    resetReimbursementDeleteStatus,
    resetReimbursementUpdateStatus
} = IVReimbursementSlice.actions

export default IVReimbursementSlice.reducer